<template>
	<div class="panel_sale">
		<div class="list"> <!-- v-if="type==='list'" -->
			<bingliList></bingliList>
		</div>
	</div>
</template>
<script>
	import bingliList from "./comp/bingli_list.vue"
	export default {
		components:{bingliList},
		data(){
			return{
				
			}
		},
		computed:{
			type(){
				return this.$store.state.jiyang.type;
			}
		},
		mounted(){
			
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	.settlementBox{
		position: absolute;
		z-index: 11;
		bottom:0;
		width:100%;
	}
	.list{
		height: 100%;
	}
	.add{
		height: 100%;
	}
}
</style>
